import Attributes from './attributes';
import Elements from './elements';

export default {
    Attributes,
    Elements
}